import * as angular from 'angular';

import { GroupStepDetailsChart, Margins, DateProcessingResult } from './groupStepDetails.chart';
import { ComponentDefinition } from '../../models';

class GroupStepDetailsController implements angular.IComponentController {
    private _chart: GroupStepDetailsChart;
    data: {
        stepName: string;
        results: { timeStamp: Date, status: number, message: string }[];
    };
    margins: Margins;
    messageFormat?: (d: { result: DateProcessingResult }) => string;
    yPos: 'left' | 'right';

    static $inject = ['$element', '$translate'];
    constructor(private _$element,
        private _$translate: angular.translate.ITranslateService) {
        this._chart = new GroupStepDetailsChart('#groupStepDetails .panel-body .widget-content')
            .labelFormat(d => {
                return this._$translate.instant(d);
            });
    }

    $onInit() {
        if (this.margins) {
            this._chart.margins(this.margins);
        }
        if (!!this.messageFormat) {
            this._chart.messageFormat(d => this.messageFormat({ result: d }));
        }
        if (!!this.yPos) {
            this._chart.yPos(this.yPos);
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['data'] && changesObj['data'].currentValue) {
            const newValues = changesObj['data'].currentValue;
            this._chart.render(newValues);
        }
    }
}

export const wtGroupStepDetails: ComponentDefinition = {
    componentId: 'wtGroupStepDetails',
    controller: GroupStepDetailsController,
    template: require('./groupStepDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        data: '<',
        title: '@?',
        margins: '<',
        isLoading: '<?',
        messageFormat: '&?',
        yPos: '<?',
    }
};
